import { IS_PRODUCTION } from '@import-io/js-sdk/constants/host-constants';

export const TARGET_BLANK = '_blank';

// TODO: store in environment variables
export const RECURLY_KEY = IS_PRODUCTION ? 'ewr1-AebmPzzu6ZXA4aRiXXan32' : 'ewr1-1Cfz4EuQU0vvSnCZA5hgh7';

export const DEFAULT_MESSAGE_DURATION = 5;
